import { Controller } from '@hotwired/stimulus'
import { snapshotHubPreviewLines } from '../utils/imh_snapshot_import_preview.mjs'

export default class extends Controller {
  static targets = ['form', 'file', 'status', 'preview', 'confirmButton']

  static values = {
    previewUrl: String,
    confirmUrl: String
  }

  async preview (event) {
    event.preventDefault()
    this.previewToken = null
    this.confirmButtonTarget.hidden = true
    this.previewTarget.replaceChildren()

    try {
      const response = await fetch(this.previewUrlValue, this.requestOptions(new window.FormData(this.formTarget)))
      const body = await response.json()
      if (!response.ok) throw new Error(body.error || 'Could not preview the mapping snapshot.')

      this.previewToken = body.preview_token
      this.renderPreview(body.hubs || [])
      const readyCount = (body.hubs || []).filter((hub) => hub.status === 'ready').length
      this.confirmButtonTarget.hidden = readyCount === 0
      this.setStatus(`Preview complete. ${readyCount} listed hub${readyCount === 1 ? '' : 's'} can be imported; skipped hubs will remain unchanged.`)
    } catch (error) {
      this.setStatus(error.message || 'Could not preview the mapping snapshot.')
    }
  }

  async confirm () {
    if (!this.previewToken || !this.fileTarget.files.length) return

    const data = new window.FormData(this.formTarget)
    data.append('preview_token', this.previewToken)
    this.confirmButtonTarget.disabled = true

    try {
      const response = await fetch(this.confirmUrlValue, this.requestOptions(data))
      const body = await response.json()
      if (!response.ok) {
        this.previewToken = null
        this.confirmButtonTarget.hidden = true
        throw new Error(body.error || 'Could not import the mapping snapshot. Preview the file again.')
      }

      this.previewToken = null
      this.confirmButtonTarget.hidden = true
      this.renderPreview(body.hubs || [])
      this.setStatus('Snapshot import completed. Only ready listed hubs were replaced; absent and skipped hubs were left unchanged.')
    } catch (error) {
      this.setStatus(error.message || 'Could not import the mapping snapshot.')
    } finally {
      this.confirmButtonTarget.disabled = false
    }
  }

  requestOptions (body) {
    return {
      method: 'POST',
      body,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
      }
    }
  }

  renderPreview (hubs) {
    const list = document.createElement('ul')
    list.className = 'list-disc pl-5 mt-2'
    hubs.forEach((hub) => {
      const lines = snapshotHubPreviewLines(hub)
      const item = document.createElement('li')
      const heading = document.createElement('strong')
      heading.textContent = lines[0]
      item.appendChild(heading)

      if (lines.length > 1) {
        const effects = document.createElement('ul')
        effects.className = 'list-disc pl-5'
        lines.slice(1).forEach((line) => {
          const effect = document.createElement('li')
          effect.textContent = line
          effects.appendChild(effect)
        })
        item.appendChild(effects)
      }

      list.appendChild(item)
    })
    this.previewTarget.replaceChildren(list)
    this.previewTarget.hidden = false
  }

  setStatus (message) {
    this.statusTarget.textContent = message
  }
}
